export default class DocumentIdentifier {
  type: string
  params: Record<string, unknown>
}
